<template>
  <div id="container">
    <BMap @loaded="onMapLoaded"></BMap>
  </div>
</template>

<script>
import BMap from '@/components/bmapGL/index.vue';
import bmapTheme from '@/utils/bmapTheme';

import { mapState } from 'vuex';
import { Engine, EmptySky } from 'mapv-three';
// import { randomRange } from '@/utils/math';
import { GeoModel } from '@/utils/bmap';
import { isEmpty } from '@/utils/is';

export default {
  components: {
    BMap
  },
  name: 'MapScene',
  mixins: [],
  computed: {
    ...mapState('app', ['theme']),
    ...mapState('device', ['monitorMode', 'monitorConfig'])
  },
  props: {
    name: String,
    sensorIndex: Number,
    droneIndex: Number,
    upPositionFlag: Boolean,
    sensorData: {
      type: Array,
      default: () => []
    },
    seneorGrade: {
      type: Object,
      default: () => {}
    },

    initMod: Boolean,
    address: {
      type: Object,
      default: () => {}
    },
    realLineData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    name: String,
    monitorConfig: {
      deep: true,
      handler(newConfig) {
        this.$map.setMapType(newConfig.mapType);
      }
    },
    theme() {
      this.setMapThemeHandler();
    },
    initMod: {
      deep: true,
      handler() {
        this.rendyLineHandler(this.sensorData);
        this.showDom = true;
      }
    },
    upPositionFlag: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.disposeFlyDataHandler('no-change');
        }
      }
    },

    sensorIndex: {
      deep: true,
      //   immediate: true,
      handler(newVal) {
        this.rendyLineHandler();

        if (this.$model) {
          this.$model.showGraph('line');
          this.$model.setProp(this.sensorData[newVal].name);
        }
      }
    },
    droneIndex: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal == undefined || oldVal == undefined) return;

        if (newVal !== oldVal) {
          //   this.disposeFlyDataHandler('change');
        }
      }
    },
    realLineData(val) {
      if (isEmpty(val)) return;
      this.$model.insertBefore(this.name, val);
    },
    address: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this.hasFired && val.longitude && val.latitude) {
          this.setMapCenter([val.longitude, val.latitude]);
          this.hasFired = false;
        }
      }
    }
  },
  data() {
    return {
      hasFired: true,
      showDom: false,
      positionData: [],
      data: [],
      max: {
        pm1: 200,
        pm25: 9999999
      },
      config: {
        center: [116.403654, 39.915546, 0], // 天安门
        // center: [116.572656, 40.088812, 0],
        // center: [116.403963, 39.91512, 0],
        pitch: 60,
        zoom: 18
      },
      defaultKey: ''
    };
  },
  create() {},
  mounted() {
    this.setMapThemeHandler();
    this.reportDatas = [];
  },
  methods: {
    rendyLineHandler() {
      if (isEmpty(this.sensorData) || isEmpty(this.seneorGrade)) return;

      let { deviceType, name } = this.sensorData[this.sensorIndex];

      let GradeDtos = [];
      if (isEmpty(this.seneorGrade[deviceType])) return;

      this.seneorGrade[deviceType].forEach(item => {
        if (item.sensorTypeCode.includes(name)) {
          GradeDtos = item.deviceSensorTypeGradeDtos;
        }
      });

      if (isEmpty(GradeDtos)) return;
      if (GradeDtos.length == 2) {
        this.gradient = {
          0: GradeDtos[0].gradeMark,
          1: GradeDtos[1].gradeMark
        };
      } else {
        this.gradient = {
          0: GradeDtos[0].gradeMark
        };

        GradeDtos.forEach((item, index) => {
          if (index !== 0 && index !== GradeDtos.length - 1) {
            let obj = {};
            let key = (item.gradeLowValue / GradeDtos[GradeDtos.length - 1].gradeLowValue).toFixed(
              2
            );
            obj[key] = item.gradeMark;
            this.gradient = { ...this.gradient, ...obj };
          }
        });
        this.gradient[1] = GradeDtos[GradeDtos.length - 1].gradeMark;

        if (isEmpty(this.gradient)) {
          this.$model.setGradient(this.gradient);
        }
      }
    },
    setMapThemeHandler() {
      if (this.$map) {
        this.$map.setMapStyleV2({ styleJson: bmapTheme[this.theme] });
      }
    },
    async onMapLoaded(map) {
      const { center, zoom } = this.config;
      this.$map = map;
      this.$map.setMapStyleV2({ styleJson: bmapTheme[this.theme] });
      map.centerAndZoom(new BMapGL.Point(center[0], center[1]), zoom);
      map.enableScrollWheelZoom();
      await this.initScene(this.config);
    },
    setMapCenter(val) {
      this.$engine.map.setCenter(val);
    },

    async initScene(config) {
      this.initMapEngine(config);
      this.initSky();
      await this.initModel();
    },

    async initMapEngine(config) {
      const { center, pitch } = config;
      const engine = new Engine(this.$map, {
        rendering: {
          enableAnimationLoop: true
        }
      });
      engine.map.setCenter(center);
      engine.map.setPitch(pitch);
      this.$engine = engine;
    },

    initSky() {
      const sky = this.$engine.add(new EmptySky());
      sky.time = 3600 * 14;
      this.$sky = sky;
    },

    async moveMapCenterAndAddPointHandler() {
      this.$map.centerAndZoom(new BMapGL.Point(116.572656, 40.088812));
    },

    async initModel() {
      // const types = ['line', 'heatmap3D', 'heatmapBlock', 'point', 'pillar'];
      this.$model = new GeoModel({
        engine: this.$engine,
        max: this.max,
        type: 'line',
        prop: 'value',
        devicePath: '/static/models/uav.glb',
        // 0, 161, 66
        gradient: {
          //   0: 'rgb(50, 250, 56)',
          0: 'rgb(0, 161, 66)',
          0.5: 'rgb(250, 250, 56)',
          1: 'rgb(250, 50, 56)'
        }
      });

      (await this.$model.init()).render();
    },

    // eslint-disable-next-line no-unused-vars
    disposeFlyDataHandler(type) {
      if (isEmpty(this.sensorData)) return;

      const result = this.sensorData.reduce((acc, item) => {
        // this.max[item.name] = item.value;

        this.$model.setMax(this.max);

        const key = item.name;
        if (!acc[key]) {
          acc[key] = {
            values: item.value
          };
        } else {
          acc[key].values = item.value;
        }
        return acc;
      }, {});

      const keys = Object.keys(result);

      if (!this.defaultKey) {
        this.defaultKey = keys[0];
        this.$model.setProp(keys[0]);
      }

      const objData = {};

      keys.forEach(item => {
        objData[item] = result[item].values || 0;
      });

      objData.position = [this.address.longitude, this.address.latitude, this.address.height];
      this.data.push(objData);
      this.$model.setData(this.name, objData);
    }
  },
  beforeDestroy() {}
};
</script>

<style scoped>
#container {
  width: 100%;
  height: 100%;
}
</style>
